// 系统服务地址配置
export const SYSTEM_SERVICE_BASE = "/api/service-chijing-system/api/system";
// 用户服务地址配置
export const USERS_SERVICE_BASE = "/api/service-chijing-users/api/user";
// 代理服务地址配置
export const AGENT_SERVICE_BASE = "/api/service-chijing-agent/api/agent";
